import { useState, useEffect } from "react";

// Define the interface for your JSON data structure
interface BlobJsonData {
  equippedSchools: number;
  donatedBooks: number;
  supportedKids: number;
}

interface UseAzureBlobDataReturn {
  data: BlobJsonData | null;
  loading: boolean;

  refetch: () => void;
}

interface UseAzureBlobDataOptions {
  blobUrl: string;
  autoFetch?: boolean;
}

const blobUrl =
  "https://donatebooks.blob.core.windows.net/statistics/statistics.json";
const useAzureBlobData = (): UseAzureBlobDataReturn => {
  const [data, setData] = useState<BlobJsonData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (!blobUrl) {
      console.log("Blob URL is required");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(blobUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        console.error(
          `HTTP Error: ${response.status} - ${response.statusText}`
        );
      }

      const jsonData: BlobJsonData = await response.json();

      // Validate that the JSON has the expected structure
      if (!jsonData || typeof jsonData !== "object") {
        throw new Error("Invalid JSON data structure");
      }

      setData(jsonData);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "An unknown error occurred";
      console.log(errorMessage);
      console.error("Error fetching Azure Blob data:", err);
    } finally {
      setLoading(false);
    }
  };

  const refetch = () => {
    fetchData();
  };

  return {
    data,
    loading,
    refetch,
  };
};

export default useAzureBlobData;
export type { BlobJsonData, UseAzureBlobDataReturn, UseAzureBlobDataOptions };
